<template>
  <div class="content">
    <div class="nav">
      <div class="nav-left">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <!-- <el-tab-pane label="9/20" name="first"></el-tab-pane>
          <el-tab-pane label="9/21" name="second"></el-tab-pane>
          <el-tab-pane label="9/22" name="third"></el-tab-pane>-->
          <el-tab-pane
            v-for="(item,index) in tableData1"
            :key="index"
            :label="item.name"
            :name="item.name"
          ></el-tab-pane>
        </el-tabs>
        <!-- <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/20</div>
        <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/21</div>
        <div
          class="button"
          :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
          @click="prev"
        >9/22</div>-->
      </div>
      <div class="nav-right">
        <div>
          共
          <span style="color:#0D94FF">{{all}}</span>条/每页
          <span style="color:#0D94FF">8</span>条
        </div>
      </div>
    </div>
    <div class="table column-center" v-if="tableData.length !== 0">
      <el-table
        ref="singleTable"
        :header-cell-style="tableHeaderColor"
        :row-class-name="tableRowClassName"
        :data="tableData"
        :row-style="{height:'64px'}"
        stripe
        highlight-current-row
        style="width: 100%;font-weight:100;font-family:'Source Han Sans CN';"
      >
        <el-table-column type="index" fixed label="序号" width="100px"></el-table-column>
        <el-table-column property="loopName" width="162" fixed label="回路名称"></el-table-column>
        <el-table-column property="equipmentName" width="150" fixed label="设备名称"></el-table-column>
        <el-table-column property="eventClassification" width="150" fixed label="事件分类"></el-table-column>
        <el-table-column property="eventType" fixed width="170" label="事件类型"></el-table-column>
        <el-table-column property="startDate" width="220" fixed label="发生时间"></el-table-column>
        <el-table-column property="endDate" width="220" fixed label="结束时间"></el-table-column>
        <el-table-column property="eventDesc" width="220" fixed label="报警描述"></el-table-column>
      </el-table>
    </div>
    <!-- <div v-else class="row-center tip">
      <img src="../assets/img/not_found_data.png" alt />
    </div>-->
    <div class="mar" v-else>
      <div class="tors">
        <img src="../assets/img/not_found_data.png" alt />
        <div class="oP">
          暂无数据，请尝试
          <span class="a" @click="add()" style="color:#0D94FF">刷新</span>或选择回路
        </div>
      </div>
    </div>
    <!-- <div style="margin-top: 20px">
      <el-button @click="setCurrent(tableData[1])">选中第二行</el-button>
      <el-button @click="setCurrent()">取消选择</el-button>
    </div>-->
    <div class="pagination" v-if="tableData.length !== 0">
      <div
        style="margin-right:31px"
        :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#999999' : '' "
        @click="toFirst"
      >首页</div>
      <div
        class="button"
        :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#999999' : '' "
        @click="prev"
      >上一页</div>

      <div>
        <el-pagination
          layout=" pager"
          :total="all"
          @current-change="pageCurrentChange"
          :current-page.sync="currentPage"
          :page-size="8"
          :page-count="5"
        ></el-pagination>
      </div>
      <div
        class="button"
        :style="end == all ? 'cursor:not-allowed;color:#999999' : '' "
        @click="next"
      >下一页</div>
      <div
        style="margin-left:31px"
        :style="end == all ? 'cursor:not-allowed;color:#999999' : '' "
        @click="toEnd"
      >尾页</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],

      tableData1: [
        {
          name: "9/20",
          devices: [
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },

            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
          ],
        },
        {
          name: "9/21",
          devices: [],
        },
        {
          name: "9/22",
          devices: [
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },

              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },  {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },  {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
              {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "欠压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过压报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "线缆温度过高", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "分闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "分合闸", //事件分类：跳闸 越限 分合闸
              eventType: "合闸", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "越限", //事件分类：跳闸 越限 分合闸
              eventType: "过流报警", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
            {
              loopName: "名称",
              equipmentName: "某某电柜",
              eventClassification: "跳闸", //事件分类：跳闸 越限 分合闸
              eventType: "/", //事件类型
              startDate: "2020年9月30日 10:30",
              endDate: "2020年9月30日 10:30",
              eventDesc: "事件描述事件描述",
            },
          ],
        },
      ],
      currentRow: null,
      first: 0,
      end: 0,
      all: 0,
      currentPage: 1,

      activeName: "",
    };
  },

  computed: {
    setTableData() {
      let data = [];
      this.tableData1.forEach((l) => {
        if (this.activeName == l.name) {
          l.devices.map((l) => {
            data.push(l);
          });
        }
      });
      if (data.length === 0) {
        return [];
      } else {
        return data;
      }
    },
  },
  watch: {},
  mounted() {
    this.tableLocal();
    console.log(window.sessionStorage.getItem("tast"));
    // this.activeName = this.tableData1[2].name;
    this.all = this.setTableData.length;
    this.getPages();
  },
  beforeDestroy() {
    window.sessionStorage.removeItem("tast");
  },
  methods: {
    //刷新页面
    add() {
      this.$router.go(0);
    },
    //判断当前tabs的值
    tableLocal() {
      // console.log(window.sessionStorage.getItem('tast'))
      if (window.sessionStorage.getItem("tast") != null) {
        this.activeName = sessionStorage.getItem("tast");
      } else {
        this.activeName = this.tableData1[2].name;
      }
    },

    handleClick(e) {
      window.sessionStorage.setItem("tast", e.name);
      this.activeName == e.name;
      this.all = this.setTableData.length;
      this.currentPage = 1;
      this.getPages();
    },
    prev() {
      let length = this.all;
      this.first = this.first - 8 < 1 ? 1 : this.first - 8;
      this.end = this.first + 7 > length ? length : this.first + 7;
      this.tableData = this.setTableData.slice(this.first - 1, this.end);
      this.currentPage = this.end / 8;
    },
    next() {
      let length = this.all;
      this.first = this.first + 8 < length ? this.first + 8 : this.first;
      this.end = this.end + 8 < length ? this.end + 8 : length;
      this.tableData = this.setTableData.slice(this.first - 1, this.end);
      this.currentPage = Math.ceil(this.end / 8);
    },
    toEnd() {
      let length = this.all;
      this.first = length - (length % 8) + 1;
      this.end = length;
      this.tableData = this.setTableData.slice(this.first - 1, this.end);
      this.currentPage = Math.ceil(this.end / 8);
    },
    toFirst() {
      let length = this.all;
      this.first = 1;
      this.end = 8 < length ? 8 : length;
      this.tableData = this.setTableData.slice(this.first - 1, this.end);
      this.currentPage = Math.ceil(this.end / 8);
    },
    //改变表头
    //改变table颜色
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return "background-color:#E0E5EC;color: #000000;font-weight: 500;";
      }
    },
    pageCurrentChange() {
      let length = this.all;
      let first = (this.currentPage - 1) * 8;
      this.first = first + 1 < length ? first + 1 : 1;
      this.end = this.currentPage * 8 < length ? this.currentPage * 8 : length;
      this.tableData = this.setTableData.slice(this.first - 1, this.end);
    },
    //表格颜色
    //改变table颜色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 != 0) {
        //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
        return "background-color:#FAFBFC;";
      }
      return "";
    },
    async getPages() {
      if (this.all == 0) {
        this.first = 0;
        this.end = 0;
        this.tableData = [];
      } else {
        this.first = 1;
        this.end = this.all < 8 ? this.all : 8;
        this.tableData = this.setTableData.slice(this.first - 1, this.end);
      }
    },
  },
};
</script>

<style lang="less">
.content {
  width: 1392px;
  height: 760px;
  display: flex;
  flex-direction: column;

  align-items: center;

  .table {
    width: 1392px;
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .nav {
    width: 1392px;
    height: 75px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .nav-left {
      width: 300px;
      justify-content: space-between;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .el-tabs--card > .el-tabs__header {
      border: 0;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
      color: white;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: none;
    }

    .el-tabs--card > .el-tabs__header .el-tabs__item {
      border: 1px solid #d9d9d9;
      width: 84px;
    }

    .el-tabs__item {
      font-size: 18px;

      font-family: Source Han Sans CN;
    }

    .el-tabs__item:hover {
      color: #000000;
      cursor: pointer;
    }

    .el-tabs__item.is-active {
      color: #000;

      background: linear-gradient(
        rgba(3, 13, 24, 0.65),
        rgba(3, 13, 24, 0.5),
        rgba(3, 13, 24, 0.65)
      );
    }

    .nav-right {
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .button {
      width: 84px;
      height: 40px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .pagination {
    height: 6vh;
    //width: 300px;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    font-size: 14px;

    .button {
      width: 74px;
      height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .column-center {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
  }

  .mar {
    margin: auto;
    .tors {
      width: 400px;
      height: 400px;
      margin: auto;
      // background-color: red;
      text-align: center;
      img {
        margin-top: 30px;
        margin-right: 80px;
        margin-left: 80px;
      }
      .oP {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        margin-top: 24px;
      }
      .a {
        cursor: pointer;
      }
    }
  }
}
</style>